
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poweron-pro",
      function () {
        return require("private-next-pages/poweron-pro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poweron-pro"])
      });
    }
  